import axios from 'axios';

export const httpClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 15_000,
  headers: { 'Content-Type': 'application/json' },
  // Send + receive the HttpOnly reload-re-establish refresh cookie (FEATURE_005): login stores it, the boot
  // /auth/refresh sends it, logout clears it. The session/ID token itself still lives in memory only.
  withCredentials: true,
});
